






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { timeout } from '@/utils/common'

@Component
export default class ComponentModelosCargaRemuneracao extends Vue {
  loadModelosCargaRemuneracao: boolean = false

  get modalModelosCargaRemuneracao() { return this.getFinanceiroStore.modal.modelosCargaRemuneracao }
  set modalModelosCargaRemuneracao(value: boolean) { this.getFinanceiroStore.setModal({ name: 'modelosCargaRemuneracao', value }) }

  get loadingModelosCargaRemuneracao() { return this.loadModelosCargaRemuneracao }
  set loadingModelosCargaRemuneracao(value: boolean) { this.loadModelosCargaRemuneracao = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get tiposCarga() {
    return this.getFinanceiroStore.tiposCarga
  }

  get tipoCargaSelected() {
    return this.getFinanceiroStore.tipoCargaSelected
  }

  set tipoCargaSelected(value: any) {
    this.getFinanceiroStore.setTipoCargaSelected(value)
  }

  async getTipoCargaDownload(tipoArquivo: string) {
    this.loadingModelosCargaRemuneracao = true
    const response = await this.getFinanceiroStore.getTipoCargaDownload(tipoArquivo)
    if (response.success) {
      const link = document.createElement('a')
      link.href = this.getFinanceiroStore.downloadTipoCarga
      link.download = tipoArquivo === 'Layout' ? 'modelo_carga.xlsx' : 'orientacao_carga.pdf'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      EventBus.$emit('setSnackbar', { show: true, text: 'Relatórios emitidos com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao realizar o download!', icon: 'warning', color: '#C62828' })
    }
    this.loadingModelosCargaRemuneracao = false
  }

  @Watch('modalModelosCargaRemuneracao')
  onModalModelosCargaRemuneracaoChange(value: boolean) {
    if (!value) {
      this.tipoCargaSelected = null
    }
  }
}
